import { createInstance as parentCreateInstance } from 'i18next'
import languagedetector from 'i18next-browser-languagedetector'
import backend from 'i18next-http-backend'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next/initReactI18next'

export function createInstance(
  config: {
    withDetector?: boolean
  } = {},
) {
  const i18nInstance = parentCreateInstance()

  // The browser detector must never run on the server: all of its sources are
  // client only, except `navigator` - which node >= 21 provides as a global and
  // which reports the *server* locale (e.g. `en-US`). That leaked into every
  // SSR-ed `i18n.language` and produced links like `/en-US/app` that the client
  // then hydrated as `/en/app`. On the server the language comes from the route.
  if (config.withDetector !== false && typeof window !== 'undefined') {
    i18nInstance.use(languagedetector)
  }

  i18nInstance.use(backend)
  i18nInstance.use(ICU)
  i18nInstance.use(initReactI18next)


  return i18nInstance
}
